import template from "./client-create.html";
import controller from "./client-create.controller";
import "./client-create.scss";

const ClientCreateComponent = {
    template,
    controller,
    controllerAs: "ClientCreate"
};

export default ClientCreateComponent;


// WEBPACK FOOTER //
// ./sources/components/clients/client-create/client-create.component.js